import React from 'react'
import { useNavigate, Link } from 'react-router-dom'
import './LandingPage.css'

const PrivacyPolicyPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="landing-page">
      <nav className="landing-nav">
        <div className="nav-container">
          <div className="logo">
            <h2>Spread Agent</h2>
          </div>
          <div className="nav-links">
            <Link to="/" className="nav-link">ホーム</Link>
            <Link to="/login" className="nav-link">ログイン</Link>
            <Link to="/signup" className="cta-button">登録</Link>
          </div>
        </div>
      </nav>

      <div className="terms-container" style={{ maxWidth: '800px', margin: '80px auto 100px', padding: '0 20px', minHeight: 'calc(100vh - 400px)' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '2rem', textAlign: 'center' }}>プライバシーポリシー</h1>

        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <p style={{ marginBottom: '1.5rem' }}>最終更新日: 2026年9月16日</p>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>1. 基本方針</h2>
            <p>
              株式会社kintsuba（以下「当社」といいます。）は、当社が提供するサービス「spread.」（以下「本サービス」といいます。）におけるユーザーの個人情報の保護の重要性を認識し、個人情報の適切な取得、利用、保管、管理を行います。本ポリシーは、当社が取得する情報の種類、利用目的、第三者提供、安全管理、ユーザーの権利等について定めるものです。
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>2. 取得する情報</h2>
            <ul style={{ paddingLeft: '1.2rem' }}>
              <li>アカウント情報（氏名、メールアドレス、パスワード等）</li>
              <li>プロフィール・会社情報（会社名、役職、業種、従業員規模 等）</li>
              <li>決済情報（決済事業者を通じたトークン・請求情報等。クレジットカード番号自体は当社で保持しません）</li>
              <li>サービス利用情報（アクセスログ、IPアドレス、ブラウザ・端末情報、参照元URL、操作履歴）</li>
              <li>メール配信・リスト管理に関するデータ（宛先、件名、本文、開封・クリック等の配信結果）</li>
              <li>お問い合わせ内容（氏名、メールアドレス、メッセージ内容 等）</li>
              <li>Cookie・類似技術による情報（後述の「7. Cookie等の利用」参照）</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>3. 利用目的</h2>
            <ul style={{ paddingLeft: '1.2rem' }}>
              <li>本サービスの提供、維持、保護および改善のため</li>
              <li>ユーザー認証、アカウント管理、本人確認のため</li>
              <li>課金・請求・支払処理および不正利用の防止のため</li>
              <li>メール配信、リード管理等の本サービス機能の実行と最適化のため</li>
              <li>サポート対応、各種お問い合わせへの回答のため</li>
              <li>サービス改善、新機能の開発、品質向上、統計・分析のため</li>
              <li>規約や重要なお知らせ等の連絡、必要な通知のため</li>
              <li>法令遵守、紛争解決、権利保護のため</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>4. 第三者提供</h2>
            <p>
              当社は、次の場合を除き、ユーザーの個人情報を第三者に提供しません：
            </p>
            <ul style={{ paddingLeft: '1.2rem' }}>
              <li>ユーザー本人の同意がある場合</li>
              <li>法令に基づく場合</li>
              <li>人の生命、身体または財産の保護のために必要で、本人の同意取得が困難な場合</li>
              <li>公衆衛生の向上または児童の健全な育成推進のために特に必要で、本人同意が困難な場合</li>
              <li>国の機関等への協力が必要で、同意取得により当該事務の遂行に支障を及ぼすおそれがある場合</li>
              <li>業務委託先へ委託する場合（この場合、適切な監督を行います）</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>5. 業務委託・共同利用</h2>
            <p>
              当社は、サービス提供・決済処理・メール配信・分析等のため、必要な範囲で業務を委託する場合があります。共同利用を行う場合は、その範囲、利用目的、管理責任者等を別途公表します。
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>6. 個人情報の安全管理</h2>
            <p>
              当社は、個人情報の漏えい、滅失またはき損の防止その他の個人情報の安全管理のため、アクセス制御、暗号化、ログ管理、権限管理等、必要かつ適切な安全管理措置を講じます。また、従業者・委託先に対する必要かつ適切な監督を行います。
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>7. Cookie等の利用</h2>
            <p>
              当社は、ユーザー体験の向上、ログイン状態の維持、利用状況の把握、パフォーマンス改善等の目的で、Cookie、ローカルストレージ、ビーコン等の技術を利用します。ブラウザ設定によりCookieを無効化できますが、サービスの一部機能が利用できなくなる場合があります。
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>8. 解析ツール・広告</h2>
            <p>
              当社は、サービス利用状況の分析や品質向上のため、第三者の解析ツールを利用する場合があります。これらの事業者はCookie等を用いて匿名化された情報を収集する場合があります。詳細は各事業者のプライバシーポリシーをご確認ください。
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>9. 保有期間</h2>
            <p>
              当社は、取得目的の達成に必要な範囲で情報を保有し、目的達成後は速やかに消去または匿名化します。ただし、法令に基づく保存義務がある場合はこの限りではありません。
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>10. ユーザーの権利</h2>
            <p>
              ユーザーは、当社が保有する自己の個人情報について、開示、訂正、追加、削除、利用停止等を求めることができます。具体的な手続きについては、下記「13. お問い合わせ窓口」までご連絡ください。
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>11. 未成年者の利用</h2>
            <p>
              未成年のユーザーが本サービスを利用する場合は、必ず保護者の同意を得てください。
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>12. 国外移転</h2>
            <p>
              当社は、クラウドサービス等の利用に伴い、個人情報を日本国外で取り扱う場合があります。この場合、法令に基づき適切な保護措置を講じます。
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>13. お問い合わせ窓口</h2>
            <p>
              本ポリシー、個人情報の取扱い、各種権利行使に関するお問い合わせは、当社サポート窓口までご連絡ください。
            </p>
            <ul style={{ paddingLeft: '1.2rem' }}>
              <li>会社名：株式会社kintsuba</li>
              <li>メール：support@kintsuba.ai</li>
              <li>件名に「プライバシーに関する問い合わせ」と明記してください</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>14. 本ポリシーの変更</h2>
            <p>
              当社は、法令の改正やサービス内容の変更等に応じて、本ポリシーの内容を改定することがあります。重要な変更がある場合は、当社ウェブサイト上で告知または個別に通知します。
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>15. Google ユーザーデータの取扱いおよび Limited Use（限定利用）への準拠</h2>
            <p style={{ marginBottom: '1rem' }}>
              本サービスは、ユーザーが自身の Gmail アカウントから営業・フォローアップメールを送信できるよう、Google OAuth を通じて <code>https://www.googleapis.com/auth/gmail.send</code> スコープ（および <code>userinfo.email</code>、<code>openid</code>）へのアクセスを、ユーザーの明示的な同意に基づいて取得します。
            </p>
            <ul style={{ paddingLeft: '1.2rem', marginBottom: '1rem' }}>
              <li>当社は <code>gmail.send</code> を用いて、ユーザーが本サービス内で作成し「送信」を押した送信メールを、ユーザー本人の Gmail アカウントから配信する目的にのみ使用します。</li>
              <li>当社は、ユーザーのメールボックス内のメッセージを読み取り、一覧取得、変更、ラベル付け、アーカイブ、削除することは一切ありません。</li>
              <li>Google から取得するデータのうち当社が保存するのは、暗号化された OAuth アクセス／リフレッシュトークンと、ユーザー自身が作成した送信メール本文のみです。</li>
              <li>ユーザーは、本サービスの設定画面の「Gmail連携を解除」からいつでも連携を解除でき、また <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener noreferrer">https://myaccount.google.com/permissions</a> からも取り消せます。解除時にトークンは削除されます。</li>
            </ul>
            <p style={{ marginBottom: '1rem' }}>
              <strong>AI／機械学習サービスへの非提供：</strong> 当社は、Google API から取得したユーザーデータ（生データ・加工データ・派生データを含む）を、基盤モデルや汎用の AI／機械学習モデルの作成・学習・改善のために使用、転送、または販売することはありません。当社が利用する第三者 AI サービス（OpenAI、Google Gemini）には、Gmail／Google Workspace の受信メール内容などの Google ユーザーデータを送信しておらず、これらは公式 API 経由で当該データを学習に用いない条件の下で、営業先の公開リサーチ情報とユーザーが作成した文面の生成にのみ利用します。
            </p>
            <p style={{ marginBottom: '1rem' }}>
              Spread Agent が Google API から受領した情報の使用および転送は、
              <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer">Google API Services User Data Policy</a>
              （Limited Use 要件を含む）に準拠します。
            </p>
            <p style={{ marginBottom: '0' }}>
              <em>
                Spread Agent&apos;s use and transfer of information received from Google APIs to any other app will adhere to the
                {' '}
                <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer">Google API Services User Data Policy</a>, including the Limited Use requirements.
              </em>
            </p>
          </section>

          <section style={{ marginBottom: '4rem' }}>
            <p style={{ marginTop: '3rem', textAlign: 'center' }}>以上</p>
          </section>
        </div>
      </div>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>Spread Agent</h4>
              <p>AIで営業を自動化</p>
            </div>
            <div className="footer-section">
              <h4>製品</h4>
              <ul>
                <li><Link to="/#features">機能</Link></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>サポート</h4>
              <ul>
                <li><Link to="/#contact">お問い合わせ</Link></li>
                <li><button type="button" className="footer-link" onClick={() => navigate('/company-profile')}>会社概要</button></li>
                <li><button type="button" className="footer-link" onClick={() => navigate('/terms-of-service')}>利用規約</button></li>
                <li><button type="button" className="footer-link" onClick={() => navigate('/privacy-policy')}>プライバシーポリシー</button></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Spread Agent. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default PrivacyPolicyPage
